  <div *ngIf="errorMessage" class="bg-white mb-5 mt-5 py-5 text-center error-container heading-4"> 
   <img class="mb-3" src="assets/themes/icons/restricted-content-placeholder.svg" /><br/>
    <span class="color-grey-500">{{errorMessage}}</span>
  </div>
  <div class="ncp-container" *ngIf="ncpDetail">
    <div class="py-3 rounded-corners-12 top-banner"
      [ngStyle]="{'background-image': 'url('+ncpDetail.ncp_template.image.web_listing_image+')'}" >
        <div class="text-center py-4">
          <p class="paragraph-bold mb-2">
              <span class="color-white">{{ncpDetail.ncp_template.text.banner_header_text}}</span>
            </p>
          <div class="text-white px-3 d-flex align-items-center justify-content-center heading-2">
            <img 
              [src]="ncpDetail.ncp_template.image.icon" 
              onerror="this.src='assets/images/game/docquity-game.svg'" />
            <span class="ml-4 text-left">{{ncpDetail.title}}</span>
          </div>
        </div>
    </div>
    <div class="row ncp-list"
      infiniteScroll
      [infiniteScrollDistance]="3"
      [infiniteScrollThrottle]="1000"
      (scrolled)="onScroll()">
      <ng-container *ngIf="productList.length > numbers.ZERO">
        <div class="col-xl-4 col-lg-6 col-md-6" *ngFor="let product of productList">
          <app-game-card
            [cardType]="cardTypeConst.SINGLE"
            [imgHeight]="'imgHeight'"
            [product]="product"
            [channel] = "ncpDetail?.channel"
            [callingFrom]="screenName.NCP_SUBTYPE_LISTING_PAGE">
          </app-game-card>
        </div>
      </ng-container>
      <div class='text-center'>
        <img *ngIf="!isFinished"
          class="text-center"
          src="assets/themes/images/img-video-loader.gif"
          width="40"
          height="40"
          id="loadmore_games">
      </div>
    </div>
  </div>